/* global window */

import MiscUtils from './MiscUtils'

const IntercomUtils = {
  APP_ID: 'wk0ji2r6',
  intercomUid: '',

  initIntercom: member => {
    // Don't show intercom inside dev environment
    if (MiscUtils.STAGE === 'dev') {
      return
    }
    // Same user. Nothing to do
    if ((member && member.userId === IntercomUtils.intercomUid)
      || (!member && IntercomUtils.intercomUid === 'general')) {
      return
    }
    // Shutdown previous session
    window.Intercom('shutdown')
    // Start new session
    window.Intercom('boot', {
      app_id: IntercomUtils.APP_ID,
      user_id: member.userId,
      name: member.displayName
    })
    // Save current user
    IntercomUtils.intercomUid = member.userId || 'general'
  }

}

export default IntercomUtils



// WEBPACK FOOTER //
// ./src/infra/IntercomUtils.js